import { createContext, Dispatch, SetStateAction } from 'react'

export interface NotificationContextProps {
  contextHeaderNotificationMessage: string;
  setContextHeaderNotificationMessage: Dispatch<SetStateAction<string>>
}

export const NotificationContext = createContext<NotificationContextProps>({} as NotificationContextProps)
